import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import GamePopupDialog from "./ProductPopup";

export default function ProductCard({ data }) {
  return (
    <Card sx={{ maxWidth: 345, height : 400 }} className="ProductItem">
      <CardMedia
        component="img"
        alt="Game Image"
        height="140"
        image={data.thumbnail}
        className="cardMedia"
      />
      <CardContent style={{ borderLeft : "2px solid grey",
                            borderRight : "2px solid grey"}} 
                   sx={{ height : 200 }}>
        <Typography gutterBottom variant="h5" component="div">
          {data.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {data.short_description}
        </Typography>
      </CardContent>
      <CardActions sx={{ height : 60 }}
                    className="CardActionsLayer">
        <GamePopupDialog gamedata={data} />
        <Button component="a" 
                size="small"
                target="_blank"
                variant="contained"
                href={data.game_url}>
              Official Page
        </Button>
      </CardActions>
    </Card>
  );
}
